module.exports = __webpack_public_path__ + "assets/img/7_312_big.c6ad0224.jpg";